import Dialog from './Dialog.js';

import AccountExistsDialog from './AccountExistsDialog.js';
import ActivationEmailResentDialog from './ActivationEmailResentDialog.js';
import ActivationRequiredDialog from './ActivationRequiredDialog.js';
import ActivationSuccessDialog from './ActivationSuccessDialog.js';
import AlreadyActivatedDialog from './AlreadyActivatedDialog.js';
import CreateAccountDialog from './CreateAccountDialog.js';
import EulaDialog from './EulaDialog.js';
import InstitutionSignInDialog from './InstitutionSignInDialog.js';
import PendingMaintenanceDialog from './PendingMaintenanceDialog.js';
import ResetPasswordDialog from './ResetPasswordDialog.js';
import UnauthorizedLocationDialog from './UnauthorizedLocationDialog.js';
import UnknownIPAddressDialog from './UnknownIPAddressDialog.js';
import UserSignInDialogBuilder from './UserSignInDialogBuilder.js';

class DialogController {
    static create(params) {
        return new DialogController(params);
    }

    constructor({env}) {
        this.env = env;
        this.map = new Map();

        this.initEvents();
    }

    initEvents() {
        $(window).resize(() => this.current.performLayout());

        $(document).keydown(event => {
            if (['Esc', 'Escape'].includes(event.key)) {
                this.current.onEscapeKeydown();
            }
        });
    }

    create(id) {
        var params = {id, env: this.env},
            factory = {
                'activation-email-resent-dialog': () => ActivationEmailResentDialog.create(params),
                'activation-success-dialog': () => ActivationSuccessDialog.create(params),
                'already-activated-dialog': () => AlreadyActivatedDialog.create(params),
                'create-account-dialog': () => CreateAccountDialog.create(params),
                'eula-dialog': () => EulaDialog.create(params),
                'institution-sign-in-dialog': () => InstitutionSignInDialog.create(params),
                'pending-maintenance-dialog': () => PendingMaintenanceDialog.create(params),
                'reset-password-dialog': () => ResetPasswordDialog.create(params),
                'unauthorized-location-dialog': () => UnauthorizedLocationDialog.create(params),
                'unknown-ip-dialog': () => UnknownIPAddressDialog.create(params),
                'user-inactive-dialog': () => ActivationRequiredDialog.create(params),
                'user-sign-in-dialog': () => UserSignInDialogBuilder.build(params),
                'username-unavailable-dialog': () => AccountExistsDialog.create(params)
            }[id],
            dialog = factory?.() ?? Dialog.create({id});

        dialog.on('beforeShow', () => this.hideCurrent(dialog));
        dialog.on('show', () => this.setCurrent({id, dialog}));

        return dialog;
    }

    get(id) {
        if (!this.map.has(id)) {
            this.map.set(id, this.create(id));
        }

        return this.map.get(id);
    }

    hideCurrent() {
        this.current?.hide();
    }

    setCurrent({id, dialog}) {
        $(document.body).toggleClass('wait-cursor', id === 'loading-dialog');

        this.current = dialog;
    }
}

export default DialogController;